/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_NotesInputs */

const en_pricing_feature_notes = /** @type {(inputs: Pricing_Feature_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read along and take notes`)
};

const es_pricing_feature_notes = /** @type {(inputs: Pricing_Feature_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sigue el texto y toma notas`)
};

/**
* | output |
* | --- |
* | "Read along and take notes" |
*
* @param {Pricing_Feature_NotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_notes = /** @type {((inputs?: Pricing_Feature_NotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_NotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_feature_notes(inputs)
	return en_pricing_feature_notes(inputs)
});